<wiz-vgroup maxHeight="200px" width="100%" style="overflow: auto !important;" padding="10px" gap="1">
    <wiz-hgroup *ngFor="let entry of trimEntries" [verticalAlign]="'center'" width="100%"
    style="padding-right: 5px;">
      <wiz-text-input #tiLabel
      [id]="entry.languageCode"
      [wizShowLabel]=false
      [wizValue]="entry.label"
      [manageModel]=false width="100%"
      [wizMaxChars]="wizMaxChars"></wiz-text-input>
      <wiz-image [sourceObservable]="entry.languageIcon" height="24px" width="24px" style="margin-bottom: 5px;"></wiz-image>
    </wiz-hgroup>
</wiz-vgroup>
